<div class="srm-overlay" (click)="onCancel()">
  <div class="srm-modal" (click)="$event.stopPropagation()">
    <header class="srm-head">
      <div class="srm-head-titleblock">
        <h2 class="srm-title">Ticket Usage</h2>
        <p class="srm-sub">How the ticket may be used — seeds a test row</p>
      </div>
      <button type="button" class="srm-close" (click)="onCancel()" aria-label="Close">×</button>
    </header>

    <div class="srm-body">
      <div class="srm-field">
        <span class="srm-label">Usage type</span>
        <div class="srm-toggle">
          <button type="button" class="srm-toggle-btn"
                  [class.srm-toggle-btn--active]="dayUsage === 'single'"
                  (click)="setDayUsage('single')">Single Day</button>
          <button type="button" class="srm-toggle-btn"
                  [class.srm-toggle-btn--active]="dayUsage === 'multi'"
                  (click)="setDayUsage('multi')">Multi-Day</button>
        </div>
      </div>

      <div class="srm-field">
        <span class="srm-label">Entry</span>
        <div class="srm-radio-row">
          <label class="srm-radio">
            <input type="radio" name="entryUsage" value="one_time"
                   [checked]="entryUsage === 'one_time'"
                   (change)="entryUsage = 'one_time'" />
            One-time use
          </label>
          <label class="srm-radio">
            <input type="radio" name="entryUsage" value="unlimited"
                   [checked]="entryUsage === 'unlimited'"
                   (change)="entryUsage = 'unlimited'" />
            Unlimited (re-entry)
          </label>
        </div>
      </div>
    </div>

    <footer class="srm-foot">
      <button type="button" class="srm-btn srm-btn-cancel" (click)="onCancel()">Cancel</button>
      <button type="button" class="srm-btn srm-btn-save" (click)="onConfirm()">Save rule</button>
    </footer>
  </div>
</div>
